import { RequestDocumentDTO } from 'app/shared/model/RequestDocumentDTO.model';
import { RequestInsuredGoodDocumentDTO } from 'app/shared/model/RequestInsuredGoodDocumentDTO.model';
import { RetreivedDamagedGoodDTO } from 'app/shared/model/retreivedDamagedGoodDTO.models';

export interface Claim {
  claimNumber: string;
  status: string;
  providerLabel: string;
  retrievedDamagedGood: Array<RetreivedDamagedGoodDTO>;
  relayPoint?: string;
  trackingNumber?: string;
  idSinistre?: string;
  idClient?: string;
  idContact?: string;
  idGarantie?: string;
  idDetailGarantie?: string;
  requestInsuredGoodDocumentList: Array<RequestInsuredGoodDocumentDTO>;
}

export const initialState: Claim = {
  claimNumber: '',
  status: '',
  providerLabel: '',
  trackingNumber: null,
  idSinistre: '',
  idClient: '',
  idContact: '',
  idGarantie: '',
  idDetailGarantie: '',
  retrievedDamagedGood: [],
  requestInsuredGoodDocumentList: [],
};

export type ClaimState = Readonly<Claim>;
